import { TenMpOutlined, ThirtyFpsRounded } from "@mui/icons-material";
import { stringify } from "query-string";
import { FxmsData } from "../datas/FxData";

class Info {
  constructor(url, key, text, method) {
    this.url = url;
    this.key = key;
    this.text = text;
    this.method = method;
  }
}

/**
 * 파일명 : FxSelectBoxDatas
 * 파일내용 : SELECT 박스 기본 데이터 처리
 * 작성자 : 김종훈
 * 작성일 : 2022.11
 */
export class FxSelectBoxDatas {
  constructor() {
    this.typeInfoMap = new Map(); // 타임기준으로 목록을 가지고 있다.
    this.dataMap = new Map();

    this.setInfo("mo", "fxms/mo", "moNo", "moName", "get");
    // this.setInfo("pipe", "fxms/pipe", "pipeId", "pipeName", "put");
    this.setInfo("inlo", "fxms/inlo", "inloNo", "inloName", "get");
    this.setInfo("model", "fxms/model", "modelNo", "modelName", "get");
    this.setInfo("sensor", "fxms/sensor", "modelNo", "modelName", "get");
    this.setInfo("sensorVendr", "fxms/sensor", "modelNo", "vendrName", "get");
    this.setInfo("user", "fxms/user", "userNo", "userName", "get");
    this.setInfo("usergroup", "fxms/usergroup", "ugrpNo", "ugrpName", "get");

    this.setInfo(
      "alarmCfg",
      "fxms/alarmCfg",
      "alarmCfgNo",
      "alarmCfgName",
      "get"
    );

    this.setInfo("code", "fxms/code", "cdCode", "cdName", "get");
    this.setInfo("op", "fxms/op", "opId", "opName", "get");
    this.setInfo("menu", "fxms/menu", "opId", "opName", "get");
    this.setInfo("component", "fxms/component", "opId", "opName", "get");

    // 운영중 추가되는 데이터가 없는 경우
    this.initData(
      "alarmCode",
      "fxms/alarmCode",
      "alcdNo",
      "alcdDispName",
      "get",
      {},
      true
    );
    this.initData("psItem", "fxms/psItem", "psId", "psName", "get", {}, true);
    this.initData(
      "facPipe",
      "feFacPipe",
      "pipeId",
      "pipeName",
      "get",
      {},
      false
    );
    this.initData(
      "codeGroup",
      "fxCoCdCl/list",
      "cdClass",
      "cdClassName",
      "get",
      {},
      false
    );
  }

  /**
   * 타입에서 사용할 정보 등록
   * @param {*} type  유형
   * @param {*} url  URL
   * @param {*} key 키로 사용할 필드
   * @param {*} text  값으로 사용할 필드
   * @param {*} method URL 호출 메소드
   */
  setInfo(type, url, key, text, method) {
    this.typeInfoMap.set(type, new Info(url, key, text, method));
  }

  async initData(
    type,
    url,
    key,
    text,
    method,
    para,
    isStore = false,
    callback
  ) {
    this.typeInfoMap.set(type, new Info(url, key, text, method));
    const ret = await this.#select(type, para, isStore);
    if (callback) callback(ret);
  }

  /**
   * 데이터가 적재되었는지 확인한다.
   * @param {*} type
   * @returns
   */
  isLoaded(type) {
    const ret = this.dataMap.get(type);
    return ret !== null && ret != undefined;
  }

  sortList(type, list) {
    const tmp = [];
    for (const o of list) {
      tmp.push(o);
    }

    const info = this.typeInfoMap.get(type);

    tmp.sort(function (a, b) {
      if (a[info.text] > b[info.text]) {
        return 1;
      }
      return -1;
    });

    return tmp;
  }

  /**
   * type의 전체 데이터 목록을 설정한다.
   * @param {*} type
   * @param {*} list
   */
  setDatas(type, list) {
    this.dataMap.set(type, this.sortList(type, list));

    let msg = "";
    for (const key of this.dataMap.keys()) {
      msg += ", " + key + "=" + this.dataMap.get(key).length;
    }
    console.log("*** FxSelectBoxDatas setDatas *** " + msg);
  }

  getDatas(type, para) {
    const datas = this.dataMap.get(type);

    // console.log('*** FxSelectBoxDatas getDatas *** ', this.dataMap, datas);

    const ret = this.#filter(datas, para);

    return ret;
  }

  #makeItems(type, para) {
    const dataList = this.#getDataList(type, para);

    if (dataList === undefined) {
      return undefined;
    }
    const info = this.typeInfoMap.get(type);
    const ret = [];

    for (const data of dataList) {
      ret.push({ key: data[info.key], text: data[info.text], fxObject: data });
    }

    return ret;
  }

  #getDataList(type, para) {
    let datas = this.getDatas(type);

    console.log("*** FxSelectBoxDatas *** " + type, para, datas);

    // engId "AIR" 상단에 위치하도록 설정
    function sortByEngId(data, targetName) {
      data.sort((a, b) => {
        if (a.engId === targetName) return -1;
        if (b.engId === targetName) return 1;
        return 0;
      });
      return data;
    }
    if (type === "energy") {
      datas = sortByEngId(datas, "AIR")
    }

    // 조회된 데이터가 없으면 조회한다.
    if (datas === undefined) {
      return undefined;
    }

    if (para === null || para === undefined) {
      return datas;
    }

    const keys = Object.keys(para);
    if (keys.length === 0) {
      return datas;
    }

    const ret = this.#filter(datas, para);
    console.log("*** FxSelectBoxDatas *** " + type, para, datas, ret);

    return ret;
  }

  #copy(datas) {
    const ret = [];
    for (const o of datas) {
      ret.push(o);
    }
    return ret;
  }

  #filter(datas, para) {
    // 조회된 데이터가 없으면 조회한다.
    if (datas === undefined) {
      return undefined;
    }

    if (para === null || para === undefined) {
      return this.#copy(datas);
    }

    const keys = Object.keys(para);
    if (keys.length === 0) {
      return this.#copy(datas);
    }

    const ret = [];
    let match;
    for (let data of datas) {
      match = true;
      for (let key of keys) {
        if (data[key] + "" !== para[key] + "") {
          match = false;
          break;
        }
      }
      if (match) {
        ret.push(data);
      }
    }

    return ret;
  }

  /**
   *  Select 박스를 체움 목록을 조회한다.
   * @param {*} type
   * @param {*} para
   * @returns
   */
  getSelectItem(type, para, key = "id", text = "val") {
    let list;

    if (type === "list") {
      // 입력된 내용으로 할 경우
      list = [];
      for (let s of para.list) {
        list.push({ key: s[key], text: s[text] });
      }
    } else {
      // 늘 사용하는 경우
      list = this.#makeItems(type, para);

      if (list === undefined) {
        // 서버에서 조회해야하는 경우
        return this.#select(type, para);
      }
    }

    // console.log('*** FxSelectBoxDatas ***', type, para, list);

    return new Promise(function (resolve, reject) {
      resolve(list);
    });
  }

  #select(type, para, isStore = false) {
    const THIS = this;

    function _makeList(res) {
      const list = [];

      res.data.sort(function (a, b) {
        if (a[info.text] >= b[info.text]) {
          return 1;
        }
        return -1;
      });

      if (isStore) {
        // 코드성으로 변경되지 않으면 보관한다.
        THIS.setDatas(type, res.data);
      }

      for (let obj of res.data) {
        list.push({ key: obj[info.key], text: obj[info.text], fxObject: obj });
      }

      // console.log('*** FxSelectBoxDatas setDatas *** ' + type + ", "+ isStore, res.data);

      return list;
    }

    function _makeError() {
      const list = [];
      list.push({ key: "", text: "ERROR " + type });
      console.log("*** FxSelectBoxDatas ***", list);
      return list;
    }

    const info = this.typeInfoMap.get(type);

    if (info === undefined || info.url === undefined) {
      console.log(
        "* ERROR ***********************************************************"
      );
      console.log(
        type + " :: SELECT박스 데이터를 가져오는 방식이 정의되지 않았습니다."
      );
      console.log(
        "*******************************************************************"
      );
      return new Promise(function (resolve, reject) {
        resolve(_makeError());
      });
    }

    if (info.method === "get") {
      return new Promise(function (resolve, reject) {
        FxmsData.GET(info.url, para)
          .then(function (res) {
            console.log("*** FxSelectBoxDatas ***", info.url, res);
            resolve(_makeList(res));
          })
          .catch(function (error) {
            resolve(_makeError());
          })
          .finally(function () {});
      });
    } else {
      return new Promise(function (resolve, reject) {
        FxmsData.PUT(info.url, para)
          .then(function (res) {
            console.log("*** FxSelectBoxDatas ***", info.url, res);

            resolve(_makeList(res));
          })
          .catch(function (error) {
            console.log("*** FxSelectBoxDatas ***", error);

            resolve(_makeError());
          })
          .finally(function () {});
      });
    }
  }
}
